// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"style_tabsContainer__1D0_N","buttonContainer":"style_buttonContainer__ZRsHM","selected":"style_selected__2l3Vo","tabsContent":"style_tabsContent__10c20"};